import React from 'react'

const Card = ({ title, des, icon }) => {
  return (
    <div className="w-full px-10 h-80 rounded-lg shadow-shadowOne dark:shadow-[#1c1e22] shadow-gray-200 flex items-center  bg-gradient-to-r from-[#fdfdfd] to-[#fafafa] dark:from-[#1e2024] dark:to-[#23272b] group transition-colors duration-100 group cursor-pointer">
      <div className="h-64 overflow-y-hidden mt-4">
        <div className="flex h-full flex-col gap-10 ">
          <div className="w-10 h-8 flex flex-col justify-between">

            {icon ? (
              <span className="text-5xl dark:text-designColor text-blue-600">{icon}</span>
            ) : (
              <>
                <span className="w-full h-[2px] rounded-lg dark:bg-designColor bg-blue-600 inline-flex"></span>
                <span className="w-full h-[2px] rounded-lg dark:bg-designColor bg-blue-600 inline-flex"></span>
                <span className="w-full h-[2px] rounded-lg dark:bg-designColor bg-blue-600 inline-flex"></span>
                <span className="w-full h-[2px] rounded-lg dark:bg-designColor bg-blue-600 inline-flex"></span>
              </>
            )}
          </div>
          <div className="flex flex-col gap-2">
            <h2 className="text-xl md:text-2xl font-titleFont font-bold dark:text-gray-300 text-black">
              {title}
            </h2>
            <p className="base">{des}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Card